import businessClient from 'src/services/clients/business'
import {
  IMeta,
  IInventoryItemUpsertArgs,
  IInventoryItem,
  IInventorySelectItem,
  IEntityResource,
  IInventoryItemView,
} from 'src/common/interfaces/index.js'

const IInventoryItemListResponse = { meta: IMeta, data: { list: [IInventoryItem], resources: IEntityResource } }
const IInventorySelectItemListResponse = { meta: IMeta, data: { list: [IInventorySelectItem] } }
const IInventoryItemViewResponse = { meta: IMeta, data: { list: [IInventoryItemView], resources: IEntityResource } }
const IInventoryItemArchiveResponse = { meta: IMeta, data: { archive: [IInventoryItem] } }

export const inventoryItem = {
  /**
   * @param {{store_id: number}} filter
   * @param {string[]} resources
   * @return {Promise<IInventoryItemListResponse>}
   */
  list(filter, resources, signal) {
    return businessClient().post('inventory/item/portal/list', { filter, resources }, { signal })
  },

  /**
   * @param {{store_id: number, item_kind: number[], search: string, page: number, row_number: number}} filter
   * @return {Promise<IInventorySelectItemListResponse>}
   */
  selectItemList(filter, signal) {
    return businessClient().post('inventory/item/select-item-list', { filter }, { signal })
  },

  /**
   * @param {{store_id: number}} filter
   * @param {string[]} resources
   * @return {Promise<IInventoryItemViewResponse>}
   */
  view(filter, resources, signal) {
    return businessClient().post('inventory/item/portal/view', { filter, resources }, { signal })
  },

  /**
   * @param {IInventoryItemUpsertArgs} data
   * @return {Promise<IInsertResponse>}
   */
  upsert(data, signal) {
    return businessClient().post('inventory/item/upsert', { data }, { signal })
  },

  /**
   * @param {{ id: number }} filter
   * @return {Promise<IInventoryItemArchiveResponse>}
   */
  archive(filter, signal) {
    return businessClient().post('inventory/item/archive', { filter }, { signal })
  },

  // FIXME @Yazdan add return type
  /**
   * @param {{from: number; to: number; category_id: number;}} filter
   */
  updateOrd(filter, signal) {
    return businessClient().post('inventory/item/update-ord', { filter }, { signal })
  },
}
